(function() {
  // Check if user is in the Hello Adorn app
  function isInApp() {
    return document.documentElement.classList.contains('hello-adorn-app') || 
           document.body.classList.contains('hello-adorn-app');
  }
  
  // Initialize announcement bar with proper Swiper setup
  function initAnnouncementBar() {
    const container = document.querySelector('.swiper.announcement-bar-container');
    if (!container) return;
    
    const isApp = isInApp();
    const wrapper = container.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    
    // Get all slides
    const allSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
    let visibleSlides = [];
    
    // Filter slides based on app context
    allSlides.forEach(slide => {
      const announcementBar = slide.querySelector('.announcement-bar[data-app-only]');
      
      if (announcementBar) {
        const appOnly = announcementBar.getAttribute('data-app-only') === 'true';
        
        // Determine if slide should be visible
        const shouldShow = isApp ? appOnly : !appOnly;
        
        if (!shouldShow) {
          // Remove the slide from DOM so Swiper doesn't count it
          slide.remove();
        } else {
          visibleSlides.push(slide);
        }
      } else {
        // Slides without data-app-only attribute (like countdown) are always visible
        visibleSlides.push(slide);
      }
    });
    
    // Only initialize Swiper if there are visible slides
    if (visibleSlides.length > 0) {
      // Initialize Swiper with appropriate settings
      const announcementBar = new Swiper(".swiper.announcement-bar-container", {
        slidesPerView: 1,
        loop: visibleSlides.length > 1, // Only loop if multiple slides
        autoplay: visibleSlides.length > 1 ? {
          delay: 5000,
          disableOnInteraction: false
        } : false
      });
    } else {
      // Hide the entire container if no slides are visible
      container.style.display = 'none';
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBar);
  } else {
    initAnnouncementBar();
  }
})();